import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';

import { type IconDefinition, renderIcon } from '../util';
import { AtomButton, type AtomButtonProps } from './AtomButton';

/**
 * Button to be used to create select controls.
 */
export function SelectButton({
    ref,
    ...props
}: (AtomButtonProps & {
    icon?: IconDefinition;
}) & { ref?: React.ForwardedRef<HTMLButtonElement> }) {
    const { icon, children, className, ...rest } = props;
    return (
        <AtomButton
            ref={ref}
            {...rest}
            className={clsx(
                'flex items-center gap-2 rounded-md border border-solid border-base bg-(--neutral-1) px-3 py-[calc(0.25rem-1px)] text-left leading-6 hover:bg-(--neutral-2) focus-visible:focus-ring active:bg-(--neutral-3) aria-expanded:bg-(--neutral-3)',
                className
            )}
        >
            {renderIcon(icon, { size: 16 })}
            <span className="min-w-0 flex-1 truncate whitespace-nowrap">{children}</span>
            <Icon.ChevronDown className="size-4 text-neutral-low" />
        </AtomButton>
    );
}
